<template>
  <div class="main-content">
    <Nav />
    <div class="center-body">
      <div class="title">
        <h2>{{ $t("lang.newsinfo") }}</h2>
      </div>
      <div class="new-box" v-for="list in dataForm" :key="list.id">
        <div
          class="row"
          style="line-height:40px;margin-bottom:15px"
          @click="toNewDetail(list)"
        >
          <div
            class="item"
            style="font-size: 16px;color: #5B5B5B;font-weight: 400;cursor: pointer;"
          >
            {{ list.title }}
          </div>
          <div
            class="item"
            style="font-size: 16px;color: #8E8E8E;font-weight: 400;justify-content: flex-end;cursor: pointer;"
          >
            {{ list.createTime }}
          </div>
        </div>
        <!-- <div
          class="row"
          @click="toNewDetail(list)"
          style="margin-top: 10px;justify-content: flex-end;cursor: pointer;color: #169BD5;"
        >
          {{ $t("lang.view") }} >
        </div> -->
      </div>
      <div
        class="row news"
        style="justify-content: center;margin-top: 15px;position:relative;"
      >
        <template>
          <Page
            :total="total"
            :current="current"
            @on-change="changePage"
            show-total
          ></Page>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./nav.vue";
export default {
  name: "App",
  components: {
    Nav,
  },
  data() {
    return {
      current: 1,
      total: 0,
      dataForm: [],
    };
  },
  methods: {
    getNewsList() {
      var self = this;
      var params = {};
      params.current = this.current;
      params.pageSize = 10;
      this.$api.api.newList(params).then(function(response) {
        if (response.data.code == 200) {
          self.total = response.data.data.total;
          self.dataForm = response.data.data.records;
        } else {
          self.$toast(response.data.msg);
        }
      });
    },
    changePage(c) {
      window.scrollTo(0,0);
      this.current = c;
      this.getNewsList();
    },
    toNewDetail(list) {
      this.$localstorage.setStore("new", list);
      this.$router.push("newsDetail");
    },
  },
  mounted() {
    this.getNewsList();
  },
};
</script>
<style>
.news .ivu-page-total {
  position: absolute;
  right: 0;
  font-size: 12px;
  color: #595959;
}
.news .ivu-page-item-active {
  background-color: #ff0000;
  border-color: #ff0000;
  color: #fff;
}
.news .ivu-page-item:hover {
  border-color: #ff0000;
}
.news .ivu-page-item-active:hover a {
  color: #ffffff;
}
.news .ivu-page-next:hover,
.news .ivu-page-prev:hover {
  border-color: #ff0000;
}
.news .ivu-page-next:hover a,
.news .ivu-page-prev:hover a,
.news .ivu-page-item:hover a {
  color: #ff0000;
}
.news .ivu-page-item-active a {
  color: #fff !important;
}
</style>
<style scoped>
.main-content {
  min-height: 100%;
  width: 100%;
  min-width: 1200px;
  margin: 0 auto;
  display: block;
  position: absolute;
  margin-top: 135px;
  /* background: #f7f7f7; */
}
.center-body {
  width: 1200px;
  margin: 0 auto;
}
.title {
  padding: 25px 0 15px;
  border-bottom: 1px solid #e2e2e2;
}
.title h2 {
  height: 30px;
  line-height: 30px;
  font-size: 24px;
  color: #333333;
  padding-left: 15px;
  border-left: 4px solid #ff0000;
}
.new-box {
  margin-top: 5px;
  width: 100%;
  background: #fff;
  padding: 15px 0 5px;
  border-bottom: 1px solid #e2e2e2;
}
</style>
